import * as React from 'react';

export const LittlePayedIcon = (isHovered: boolean, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="13" viewBox="0 0 9 13" width="9" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6.656h1.286V0h3.066c1.483 0 2.472.208 3.164.832C8.406 1.456 9 2.496 9 3.952c0 1.144-.396 2.184-1.088 2.912-.89.936-1.879 1.352-3.66 1.352H2.869V9.36h5.539v1.456H2.868V13H1.187v-2.184H0v-1.56h1.286V8.112H0V6.656zm6.429-4.68c-.594-.312-1.187-.52-2.176-.52H2.868v5.2h1.088c1.385 0 2.077-.208 2.67-.728.495-.52.693-1.144.693-1.976 0-.832-.297-1.56-.89-1.976z"
      fill={isHovered ? '#CC6E09' : '#FF8400'}
      fillRule="evenodd"
    />
  </svg>
);
